// extracted by mini-css-extract-plugin
export default {"root":"FeaturedBy-root-95218f25da77d7d338ae7575b14f0554","name":"FeaturedBy-name-e0a6d149d1e36a1ba72c34d0b3a84b26"};